















































import { Vue, Component } from 'vue-property-decorator';
import Table from '@/components/Table/Index.vue';
import RecalData from '@/data/RecalData';

@Component({
  components: {
    Table,
  },
})
export default class UserOnlineView extends Vue {
  TableHead = RecalData.TableHead;
}
